export default __webpack_public_path__ + "static/tooltip-info-do-dark-2f2b91a52f15096a8aace36dafc99210f7a8fe802cee9b4e594766e3ba1a0883.png";